import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import PrimeVue from 'primevue/config';
import ruLocale from '@/assets/js/ru.json';
import 'primevue/resources/themes/lara-light-teal/theme.css';

import moment from "moment";
import "moment/locale/ru";
moment.locale("ru");

import VueMask from "v-mask";
Vue.use(VueMask);

import ApiPlugin from "./plugins/api";
Vue.use(ApiPlugin);

Vue.use(PrimeVue, {
  locale: ruLocale
});


import network from "@/api/network";
network.configure();

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
